import type { ConstructedDeliverable } from "@/types/types";
import type { RequestRenderInput } from "./ae";
import { TemplateType } from "hoxton-shared/enums/masterTemplate";
import computedValuesToComputedOverwrites from "./computedValuesToComputedOverwrites";

export default function computeAfterEffectsLayers(deliverables: ConstructedDeliverable[]) {
    const inputs = deliverables.reduce<RequestRenderInput[]>((acc, deliverable) => {
        if (deliverable.masterTemplate.adType !== TemplateType.AE) {
            return acc;
        }

        const computedOverwrites = computedValuesToComputedOverwrites(deliverable.computedValues);
        computedOverwrites.forEach((computedOverwrite, index) => {
            const settings = computedOverwrite?.settings;

            if (settings) {
                const layerManagement = {
                    ...(settings.fontSize ? { fontSize: settings.fontSize } : {}),
                    ...(settings.font ? { font: settings.font } : {})
                };

                if (Object.keys(layerManagement).length) {
                    computedOverwrites[index].layerManagement = layerManagement;
                }
            }
        });

        acc.push({
            reportingLabel: deliverable.reportingLabel,
            aeInfo: deliverable.masterTemplate?.aeInfo,
            computedOverwrites
        });

        return acc;
    }, []);

    return inputs;
}
